<script setup lang="ts">
import { computed } from 'vue';

import MiniCartLineItem from '@/components/Cart/MiniCart/MiniCartLineItem/MiniCartLineItem.vue';
import { useCartStore } from '@/shared/pinia/modules/cart';

const cartStore = useCartStore();

const cartItems = computed(() => cartStore.cart?.items ?? []);
</script>

<template>
  <div class="group relative flex w-full flex-col divide-y px-4 pb-1 md:px-8">
    <MiniCartLineItem
      v-for="(item, index) in cartItems"
      :key="item.key ?? item.id"
      :item="item"
      :line-number="index + 1"
    />
  </div>
</template>
